import { UNTRANSLATED_LOCALE } from '@va/constants';
import { isTranslationKeysAccessEnabled } from '@va/util/helpers';
import Config from 'Config';

export function getSupportedLanguages() {
  const languages: string[] = [...Config.supportedLanguages];
  if (isTranslationKeysAccessEnabled()) {
    languages.push(UNTRANSLATED_LOCALE);
  }
  return languages;
}

export function getTranslationsUrl(locale: string, customDomainOrigin?: string) {
  if (customDomainOrigin) {
    // On a custom domain, translations are served under the /analytics path
    const { pathname } = new URL(Config.translationsUrl);
    return `${customDomainOrigin}/analytics${pathname}/${locale}.json`;
  }
  return getConfigTranslationUrl(locale);
}

export function getConfigTranslationUrl(locale: string): string {
  return `${Config.translationsUrl}/${locale}.json`;
}

export const fetchTranslationsFn = async (url: string) => {
  const response = await fetch(url);

  const responseText = await response.text();

  return JSON.parse(responseText.replace(/\\n/g, '<br/>'));
};

export const fetchTranslationsFnWithFallback = async (url: string, locale: string) => {
  try {
    return await fetchTranslationsFn(url);
  } catch (error) {
    // In case we tried to fetch the translations from a custom domain and it failed, re-try using the default translation url
    if (url !== getConfigTranslationUrl(locale)) {
      return await fetchTranslationsFn(getConfigTranslationUrl(locale));
    }
    throw error;
  }
};
